import React from 'react';
import { FiImage, FiPlus } from 'react-icons/fi';

const TYPE_LABELS = {
  proofs: 'Proofs',
  selection: 'Selection',
  finals: 'Finals'
};

export default function AlbumsCard({ galleries, onManageClick, onGalleryClick }) {
  const isEmpty = !galleries || galleries.length === 0;

  return (
    <div className="ws-card">
      <div className="ws-card-header">
        <h4><FiImage size={15} /> Albums{!isEmpty && ` (${galleries.length})`}</h4>
        <button className="ws-card-action" onClick={onManageClick}>
          <FiPlus size={13} /> {isEmpty ? 'Create' : 'Manage'}
        </button>
      </div>

      {isEmpty ? (
        <div className="ws-card-empty">
          <FiImage size={32} />
          <p>No galleries created yet</p>
          <button className="cta-btn" onClick={onManageClick}>Create Gallery</button>
        </div>
      ) : (
        <div className="ws-card-body">
          <div className="albums-list-compact">
            {galleries.slice(0, 5).map(g => (
              <div
                key={g.id}
                className="album-row-compact"
                onClick={() => onGalleryClick?.(g)}
              >
                <span className="album-title">{g.title || g.name || 'Untitled'}</span>
                <div className="album-row-meta">
                  {g.type && (
                    <span className={`gallery-type-pill ${g.type}`}>
                      {TYPE_LABELS[g.type] || g.type}
                    </span>
                  )}
                  <span className="album-count">{g.image_count || 0}</span>
                  <span className={`publish-dot ${g.publish_state || 'draft'}`}
                    title={g.publish_state === 'published' ? 'Published' : 'Draft'} />
                </div>
              </div>
            ))}
          </div>
          {galleries.length > 5 && (
            <button className="ws-card-action ws-card-footer-link" onClick={onManageClick}>
              +{galleries.length - 5} more
            </button>
          )}
        </div>
      )}
    </div>
  );
}
